import palette from './palette';

export default {
  h1: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '31px',
    letterSpacing: '0.05px',
    lineHeight: '40px'
  },
  h2: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.primary.main,
    fontWeight: 500,
    fontSize: '27px',
    letterSpacing: '0.05px',
    lineHeight: '32px'
  },
  h3: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '23px',
    letterSpacing: '0.05px',
    lineHeight: '28px'
  },
  h4: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '19px',
    letterSpacing: '0.05px',
    lineHeight: '24px'
  },
  h5: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: '0.05px',
    lineHeight: '20px'
  },
  h6: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: '0.05px',
    lineHeight: '20px'
  },
  body1: {
    fontWeight: 500,
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.primary,
    fontSize: '14px',
    letterSpacing: '0.05px',
    lineHeight: '21px'
  },
  body2: {
    fontWeight: 500,
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.secondary,
    fontSize: '12px',
    letterSpacing: '0.05px',
    lineHeight: '18px'
  },
  subtitle1: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.primary,
    fontSize: '17px',
    letterSpacing: '0.05px',
    lineHeight: '25px'
  },
  subtitle2: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '15px',
    letterSpacing: '0.05px',
    lineHeight: '21px'
  },
  button: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.primary,
    fontSize: '15px'
  },
  caption: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.secondary,
    fontSize: '12px',
    letterSpacing: '0.05px',
    lineHeight: '13px'
  },
  overline: {
    // fontFamily: "proxima_nova_rgregular",
    color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.05px',
    lineHeight: '13px',
    textTransform: 'uppercase'
  }
};
